import { NOTIFICATION_STATUS_CODE } from '../../enums/notification-status-code.enum';
import { NotificationIdentifierModel } from './notification-identifier.model';

export class NotificationCompletedListModel {
    public constructor(
        public completedNotifications: Record<string, NotificationCompletedModel> = {},
        public lastSavedTimestamp = 0,
    ) {}
}

interface NotificationCompletedModel {
    id: NotificationIdentifierModel;
    status: NOTIFICATION_STATUS_CODE;
    timestampCompleted: number;
}
